<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on }">
      <v-app-bar fixed hide-on-scroll app inverted-scroll elevation="0">
        <v-toolbar-title>
          <a href="/"
            ><v-img src="@/assets/logo.svg" height="45" contain></v-img
          ></a>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <div v-if="!$vuetify.breakpoint.smAndDown">
          <v-btn text disabled color="black--text primary" to="gestion"
            >Gestion</v-btn
          >
          <v-btn text disabled color="black--text primary" to="location"
            >Location</v-btn
          >
          <v-btn text disabled color="black--text primary" to="transaction"
            >Transaction</v-btn
          >
          <v-btn text disabled color="black--text primary" to="syndic"
            >Syndic</v-btn
          >
          <v-btn
            text
            color="black--text primary"
            href="https://pagesti.monespaceclient.immo"
            >Espace client</v-btn
          >
        </div>
        <!-- <v-toolbar-title class="d-sm-none d-md-flex">
          Gestion Location • Transaction • Syndic
        </v-toolbar-title> -->
        <!-- <v-app-bar-nav-icon v-on="on"></v-app-bar-nav-icon> -->
      </v-app-bar>
      <!-- <v-btn icon large color="white" v-on="on" id="burger">
        <v-icon>mdi-menu</v-icon>
      </v-btn> -->
      <div id="burger">
        <v-spacer></v-spacer>
        <v-btn text disabled color="black--text primary" to="gestion"
          >Gestion</v-btn
        >
        <v-btn text disabled color="black--text primary" to="location"
          >Location</v-btn
        >
        <v-btn text disabled color="black--text primary" to="transaction"
          >Transaction</v-btn
        >
        <v-btn text disabled color="black--text primary" to="syndic"
          >Syndic</v-btn
        >
        <v-btn
          text
          color="black--text primary"
          href="https://pagesti.monespaceclient.immo"
          >Espace client</v-btn
        >
      </div>
    </template>
    <v-card :color="color">
      <v-card-text>
        <v-container grid-list-xl fluid pa-5>
          <v-row row wrap class="pb-5">
            <v-col>
              <v-img src="@/assets/logo.svg" width="150"></v-img>
            </v-col>
            <v-spacer></v-spacer>
            <v-col sm="auto">
              <v-btn large icon @click="dialog = false">
                <v-icon large>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row row wrap class="mt-5 pt-5" justify-space-between>
            <v-col md="4">
              <v-list nav flat class="transparent pa-0">
                <v-list-item
                  v-for="(nav, index) in navs"
                  :key="index"
                  class="pa-0"
                >
                  <v-list-item-content class="pa-0">
                    <v-list-item-title
                      v-if="nav.active"
                      class="nav-item active"
                    >
                      <a v-html="nav.title"></a>
                    </v-list-item-title>
                    <v-list-item-title v-else class="nav-item">
                      <a @click="goTo(nav.to)" v-html="nav.title"></a>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col md="3" justify>
              <v-row>
                <h4>Recrutement</h4>
                <v-btn
                  tile
                  class="mb-5"
                  href="https://taleez.com/careers/pagesti/"
                  target="_blank"
                >
                  Découvrir
                  <v-icon right>mdi-chevron-right</v-icon>
                </v-btn>
              </v-row>
              <v-row>
                <h4>Espace client</h4>
                <p>
                  Généralement, on utilise un texte en faux latin (le texte ne
                  veut rien dire, il a été
                </p>
                <v-btn
                  tile
                  href="https://pagesti.monsepaceclient.immo"
                  target="_blank"
                >
                  Se connecter
                  <v-icon right>mdi-chevron-right</v-icon>
                </v-btn>
              </v-row>
            </v-col>
            <v-spacer></v-spacer>
            <v-col md="4">
              <h4>Suivez-nous</h4>
              <v-btn fab small depressed dark class="ml-0 ma-2">
                <v-icon>fab fa-instagram</v-icon>
              </v-btn>
              <v-btn fab small depressed dark class="ma-2">
                <v-icon>fab fa-linkedin-in</v-icon>
              </v-btn>
              <v-btn fab small depressed dark class="ma-2">
                <v-icon>fab fa-twitter</v-icon>
              </v-btn>
              <v-btn fab small depressed dark class="ma-2">
                <v-icon>fab fa-medium-m</v-icon>
              </v-btn>
              <v-btn
                fab
                small
                depressed
                dark
                class="ma-2"
                @click="dialog2 = true"
              >
                <v-icon>mdi-email</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog2" max-width="750">
      <v-card>
        <v-row align="center" class="pl-5 pr-1">
          <v-col cols="12" md="6" class="pl-5">
            <h2 class="font-weight-bold">Restez informé !</h2>
            <p>
              de toute l’actualité de Pagesti en vous inscrivant a notre
              newsletter
            </p>
            <v-form>
              <v-text-field label="EMAIL" solo></v-text-field>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#D4EBFF" class="px-5">ENVOYER</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-form>
          </v-col>
          <v-col cols="12" md="6">
            <v-img src="@/assets/contactUs.png" contain></v-img>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    dialog2: false,
    navs: [
      { title: "Accueil", to: "home", active: false },
      { title: "Digitalisation", to: "digital", active: false },
      {
        title: "Partenariats",
        to: "partenariats",
        active: false,
      },
      { title: "Gestion", to: "gestion", active: false },
      { title: "Location", to: "location", active: false },
      { title: "Transaction", to: "transaction", active: false },
      { title: "Syndic", to: "syndic", active: false },
    ],
    color: null,
  }),
  created() {
    this.activeLink(this.$router.currentRoute);
    this.bgColor(this.$router.currentRoute.name);
  },
  watch: {
    $route(to) {
      this.activeLink(to);
      this.bgColor(to.name);
    },
  },
  methods: {
    goTo(link) {
      this.dialog = false;
      this.$router.push({ name: link });
    },
    bgColor(page) {
      let color;
      switch (page) {
        case "accueil":
          color = "rgba(212,235,255,.95)";
          break;
        case "gestion":
          color = "rgba(249,234,119,.95)";
          break;
        case "location":
          color = "rgba(129,249,205,.95)";
          break;
        case "transaction":
          color = "rgba(255,151,142,.95)";
          break;
        case "syndic":
          color = "rgba(141,132,248,.96)";
          break;
        default:
          color = "rgba(212,235,255,.95)";
          break;
      }
      this.color = color;
    },
    activeLink(to) {
      this.navs.map((nav, index) => {
        if (nav.to == to.name) {
          this.navs[index].active = true;
        } else {
          this.navs[index].active = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#burger {
  position: absolute;
  z-index: 1;
  top: 1.7rem;
  right: 3rem;
}
.nav-item {
  a {
    font: Bold 2.3em george;
    letter-spacing: 0.2em;
    color: #000000 !important;
    opacity: 1;
    text-transform: uppercase;
    text-decoration: none;
  }
  &.active a {
    color: rgba($color: #000000, $alpha: 0) !important;
    -webkit-text-stroke: 2px black;
  }
}
h4 {
  text-align: left;
  font: Bold 24px George;
  letter-spacing: 4.5px;
  color: #000000;
  text-transform: uppercase;
  opacity: 1;
}
</style>
